// Utils
import { extractUserIdentity } from "~utils/user"
import { getMemoryToken } from "~utils/auth-token"

// RBAC
import RULES from "~rbac/constants/rbac-rules"
import { RuleShape } from "~rbac/constants/rbac-rules"

const checkAuthorization = (action: string, data?: any): boolean => {
  const accessToken = getMemoryToken()
  if (!accessToken) return false
  const loggedUser = extractUserIdentity(accessToken)

  // Get user roles
  let roles: string[] = loggedUser.authorities.roles

  return roles.some(role => {
    // get permissions
    const permissions: Partial<RuleShape> = RULES[role]

    // role is not present in the rules
    if (!permissions) {
      return false
    }

    // get static permissions
    const staticPermissions = permissions.static

    // static rule provided for action
    if (staticPermissions && staticPermissions.includes(action)) {
      return true
    }

    // get dynamic permissions
    const dynamicPermissions = permissions.dynamic

    // evaluate dynamic permissions
    if (dynamicPermissions) {
      const permissionCondition = dynamicPermissions[action]

      // dynamic rule not provided for action
      if (!permissionCondition) {
        return false
      }

      return permissionCondition(data)
    }

    return false
  })
}

export default checkAuthorization
